'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _omitBy2 = require('lodash/omitBy');

var _omitBy3 = _interopRequireDefault(_omitBy2);

var _wrap = require('./wrap');

var _wrap2 = _interopRequireDefault(_wrap);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function omitBy(predicate, collection) {
  return (0, _omitBy3.default)(collection, predicate);
}

exports.default = (0, _wrap2.default)(omitBy);


//////////////////
// WEBPACK FOOTER
// ../redux-firebase-sync/~/updeep/dist/omitBy.js
// module id = 568
// module chunks = 0